<div class="l-section u-mt-sp-20 u-mt-tb-24 u-mt-pc-40">
  <!-- [見出し領域] -->
  <div class="p-heading-area01">
    <h2 class="p-heading-area01__title c-heading-2" [innerHTML]="'label.paymentMethod' | staticMsg"></h2>
  </div>
</div>
<br />
<!--予約のみチェックボックス-->
<div *ngIf="isCardless && hasCartId && isOnholdEligible">
  <div class="appointment-only-checkbox" [ngClass]="{ 'is-current': true }">
    <asw-checkbox
      id="anabiz-payment-appointment-only-checkbox"
      (change$)="setCreditCard(!isCreditCardPayment)"
      label="{{ 'label.appointmentOnly' | staticMsg }}"
    ></asw-checkbox>
  </div>
</div>
<!--選択：クレジットカード、予約のみ-->
<div *ngIf="!isCardless && hasCartId && isOnholdEligible">
  <ul class="l-tab-menu01__list">
    <li class="l-tab-menu01__list-item l-tab-menu01__list-item--menu" [ngClass]="{ 'is-hide': false }">
      <div class="l-tab-menu01__menu l-tab-menu01__menu--tb-pc-1col" role="tablist">
        <button
          (click)="setCreditCard(true)"
          [ngClass]="{ 'is-current': !isReserveOnly }"
          class="l-tab-menu01__menu-item"
          type="button"
          id="tab-cc"
          role="tab"
          aria-controls="panel-cc"
          [attr.tabindex]="0"
        >
          <span
            class="l-tab-menu01__menu-title-label l-tab-menu01__menu-title-label--em"
            [innerHTML]="'label.paymentMethodCreditCard' | staticMsg"
          ></span>
          <span class="l-tab-menu01__menu-mark"></span>
        </button>
        <button
          (click)="setCreditCard(false)"
          [ngClass]="{ 'is-current': isReserveOnly }"
          class="l-tab-menu01__menu-item"
          type="button"
          id="tab-cd"
          role="tab"
          aria-controls="panel-cc"
          [attr.tabindex]="1"
        >
          <span
            class="l-tab-menu01__menu-title-label l-tab-menu01__menu-title-label--em"
            [innerHTML]="'label.paymentMethodAppointmentOnly' | staticMsg"
          ></span>
          <span class="l-tab-menu01__menu-mark"></span>
        </button>
      </div>
    </li>
  </ul>
</div>
<br />
